import { takeLatest, put, call, select } from 'redux-saga/effects'
import actionTypes from '../../actions/actionTypes'
import { updateProgram } from './helpers'
import getData from '../../functions/getData'
import { getProviderImageCandidates, PROVIDER_VARIANT_STORES } from '../../functions/providerOwnedImages'
import sanitizeMovieImages from '../../functions/sanitizeMovieImages'
import {
    PROGRAM_CLI_MOVIES_ITEMS,
    PROGRAM_MOVIEMAPPING_ITEMS,
    PROGRAM_PY_MOVIES_ITEMS,
    PROGRAM_KH_MOVIES_ITEMS,
    PROGRAM_COMP_MOVIES_ITEMS,
    PROGRAM_CORTEC_MOVIES_ITEMS,
    PROGRAM_DIESEL_MOVIES_ITEMS,
    PROGRAM_MARSX_MOVIES_ITEMS,
    PROGRAM_VISTA_MOVIES_ITEMS,
    PROGRAM_TMDB_MOVIES_ITEMS,
} from '../../constants/state'

const pmMoviePkSelector = (state, metaMoviePk) => getData(state, [PROGRAM_MOVIEMAPPING_ITEMS, metaMoviePk, 'pm'])
const pmCliMovieSelector = (state, metaMoviePk) => getData(state, [PROGRAM_CLI_MOVIES_ITEMS, metaMoviePk])
const movieMappingSelector = (state, metaMoviePk) => getData(state, [PROGRAM_MOVIEMAPPING_ITEMS, metaMoviePk])

// Keys are the store names getProviderImageCandidates expects; the state
// constants are named differently (COMP -> compesoMovies, DIESEL -> dieselv2Movies).
const PROVIDER_STORE_KEYS = {
    pyMovies: PROGRAM_PY_MOVIES_ITEMS,
    khMovies: PROGRAM_KH_MOVIES_ITEMS,
    compesoMovies: PROGRAM_COMP_MOVIES_ITEMS,
    cortecMovies: PROGRAM_CORTEC_MOVIES_ITEMS,
    dieselv2Movies: PROGRAM_DIESEL_MOVIES_ITEMS,
    marsxMovies: PROGRAM_MARSX_MOVIES_ITEMS,
    vistaMovies: PROGRAM_VISTA_MOVIES_ITEMS,
    tmdbMovies: PROGRAM_TMDB_MOVIES_ITEMS,
}

// Only the stores a movie's own mapping.source actually points at are worth
// converting — the captured payload has 525 khMovies rows and only the rows
// named in this movie's mapping are ever read by getProviderImageCandidates.
// PROVIDER_VARIANT_STORES already covers the DieselV2 -> tmdbMovies case,
// since that is the store DieselV2 is configured against.
const requiredStoreNames = (mapping) => {
    const source = (mapping && mapping.source) || []
    const names = new Set()
    source.forEach(entry => {
        const variant = Object.keys(entry || {})[0]
        const storeName = PROVIDER_VARIANT_STORES[variant]
        if (storeName) names.add(storeName)
    })
    return names
}

const providerStoresSelector = (state, mapping) => {
    const stores = {}
    requiredStoreNames(mapping).forEach(storeName => {
        const stateConstant = PROVIDER_STORE_KEYS[storeName]
        if (!stateConstant) return
        const items = getData(state, stateConstant)
        stores[storeName] = items ? items.toJS() : {}
    })
    return stores
}



function* putMovie(type, pk, itemData, updateLocal, timezone = null) {
    yield put({
        type: type,
            payload: {
            pk: pk,
            itemData: itemData,
            timezone: timezone
        }
    })
}

function* putMetaOrigin(type, pk, dataMeta) {
    yield put({
        type: type,
        payload: {
            pk: pk,
            dataMeta: dataMeta
        }
    })
}

function* sanitizeImages(pk, newMovieData) {
    const oldData = yield select(pmCliMovieSelector, pk)
    const oldMovieData = yield oldData.toJS()

    const mappingData = yield select(movieMappingSelector, pk)
    const mapping = mappingData ? mappingData.toJS() : null
    const stores = yield select(providerStoresSelector, mapping)
    const candidates = yield getProviderImageCandidates(mapping, stores)

    return yield sanitizeMovieImages(newMovieData, oldMovieData, candidates)
}

function* updateMovie({payload}) {
    const { pk, dataMovie, dataMeta, dataAttributes, updateLocal, previewMoviePk, expectedStartDate, startDateDescription, timezone } = yield payload
    const pmMoviePk = yield select(pmMoviePkSelector, pk)
    const sanDataMovie = yield updateLocal ? yield dataMovie : yield call(sanitizeImages, pk, dataMovie)
    // const sanDataMovie = yield call(sanitizeImages, pk, dataMovie)

    yield call(putMovie, actionTypes.PMMOVIES_UPDATE_ITEM_EDITABLE_ATTRIBUTES, pmMoviePk, sanDataMovie, updateLocal, timezone)
    yield call(putMetaOrigin, actionTypes.METAMOVIES_UPDATE_ITEM_ORIGIN, pk, dataMeta)
    yield call(putMovie, actionTypes.CLIMOVIES_UPDATE_ITEM, pk, sanDataMovie, updateLocal)
    yield put({
        type: actionTypes.ATTRIBUTES_UPDATE,
        payload: {
            dataAttributes: dataAttributes
        }
    })

    // The preview row mirrors the start date and its description on every edit
    // route (#112). Remote routes sync now; local routes ship the marked row
    // with their next save, together with the pm and meta changes above.
    if (previewMoviePk) {
        yield put({
            type: actionTypes.PREVIEW_MOVIES_UPDATE_ITEM_DATA,
            payload: { pk: previewMoviePk, expectedStartDate, startDateDescription }
        })
        yield put({
            type: actionTypes.PROGRAM_UPDATE_ITEM_UPDATE,
            payload: { pk: previewMoviePk, objectType: 'pmPreviewMovies' }
        })
    }

    if(!updateLocal) {
        yield call(updateProgram)
    }
}

export function* watchUpdateMovieItem() {
    try {
        yield takeLatest(actionTypes.MOVIES_UPDATE_ITEM_REQUEST, updateMovie)
    } catch(e) {
        // ToDo: general error
        console.log('error!!!!!', e.message)
    }
}